import {Upload} from 'antd';
import {RcFile, UploadFile} from 'antd/es/upload/interface';
import React, {FC} from 'react';
import {useDispatch} from 'react-redux';

import {ATTORNEY_UPLOAD_EXTENSIONS} from 'components/table/table-constants';
import {selectContextRawData} from 'modules/context/context-selector';
import {selectEntityData} from 'modules/data';
import {uploadFileAction} from 'modules/data/data-actions';
import {TFileInfo, ITableEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {showMessage} from 'shared/utils';
import {useAppSelector} from 'store/config/hooks';

import {ActionButton} from '../action-button';
import {ITableActionProps} from '../table-action-types';
import {hasAttorneyName, isDocsChosen} from './button-action-upload-xml.utils';

const ButtonActionUploadXmlComponent: FC<ITableActionProps> = ({
    entityName,
    meta,
    wrapper,
    ...props
}: ITableActionProps) => {
    const dispatch = useDispatch();
    const tableData = useAppSelector(selectEntityData(entityName, EEntityType.TABLE)) as ITableEntityData;
    const selectedRows = tableData?.selectedRows || [];

    const data = useAppSelector(selectContextRawData);

    const handleUpload = (file: UploadFile<Blob>) => {
        if (!isDocsChosen(selectedRows)) return false;

        const formData = new FormData();
        formData.append('file', file as RcFile);

        const attachmentIds: number[] = [];

        selectedRows.forEach(row => {
            const listOfFiles: TFileInfo[] = row.fileList as TFileInfo[];
            if (!listOfFiles.length) return;
            attachmentIds.push(listOfFiles[0].attachmentId);
        });

        if (attachmentIds.length > 0) {
            formData.append('attachIds', attachmentIds.join(','));
        }

        if (meta.referenceUrl && data) {
            dispatch(uploadFileAction(
                entityName,
                '/loa-signature/upload',
                formData,
                '',
                'Файл доверенности подгружен к документам',
            ));
        }
        return false;
    };

    const onUploadButtonClick = () => {
        if (!isDocsChosen(selectedRows)) {
            showMessage({
                message: 'Необходимо выбрать хотя бы один документ',
                isError: true,
            });
        }
        if (hasAttorneyName(selectedRows)) {
            showMessage({
                message: 'Для одного или нескольких документов уже '
                + 'прикреплен файл доверенности, пожалуйста, выберите только те документы, '
                + 'для которых файл доверенности отсутствует',
                isError: true,
            });
        }
    };

    const Component = wrapper || ActionButton;

    return (
        <Upload
            showUploadList={false}
            beforeUpload={handleUpload}
            accept={ATTORNEY_UPLOAD_EXTENSIONS}
            disabled={!isDocsChosen(selectedRows) || hasAttorneyName(selectedRows)}
        >
            <Component
                {...props}
                onClick={onUploadButtonClick}
                actionIcon={meta.actionIcon}
                disabled={!selectedRows.length}
            >
                {meta.actionTitle}
            </Component>
        </Upload>
    );
};
export const ButtonActionUploadXml = ButtonActionUploadXmlComponent;
